export default "/images/vendor/flag-icon-css/flags/1x1/tg.svg?4abbb52870d11bce293d114b7fa12619";